/**
 * Intelligent Upgrade System
 * Orchestrates all upgrade prompts using psychological principles
 * Shows the right prompt at the right time without being pushy
 */

import { useState, useEffect } from 'react';
import { getBestTrigger, markUpgradeShown } from '../lib/upgrade-trigger-engine';
import { UpgradeTease } from './UpgradeTease';
import { SocialProofWidget } from './SocialProofWidget';
import { MilestoneUpgradePrompt } from './MilestoneUpgradePrompt';

export function IntelligentUpgradeSystem() {
  const [currentPrompt, setCurrentPrompt] = useState<any>(null);

  useEffect(() => {
    // Check if user is already premium
    const subscription = localStorage.getItem('tension_subscription');
    if (subscription && subscription !== 'free') {
      return; // Don't show upgrade prompts to premium users
    }

    // Wait 2 seconds after page load to analyze triggers
    const timer = setTimeout(() => {
      const trigger = getBestTrigger();
      if (trigger) {
        setCurrentPrompt(trigger);
        markUpgradeShown();
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Don't render anything if no prompt
  if (!currentPrompt) return null;

  // Render appropriate component based on trigger type
  switch (currentPrompt.type) {
    case 'milestone':
      return (
        <MilestoneUpgradePrompt
          milestone={currentPrompt.data.milestone}
          data={currentPrompt.data}
        />
      );
    
    case 'high-value':
    case 'pattern':
    case 'forecast':
    case 'curiosity':
      return (
        <UpgradeTease
          context={currentPrompt.data.context}
          triggerData={currentPrompt.data}
        />
      );
    
    case 'social-proof':
      return <SocialProofWidget />;
    
    default:
      return null;
  }
}
